<template>
  <LeadSelect :model-value="currentLanguage" :options="options" v-bind="$attrs" @update:model-value="onSelect" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import LeadSelect, { type LeadSelectOption } from '@/components/lead-design/LeadSelect.vue';
import { availableLanguages, currentLanguage, setLanguage } from '@/locale/translator';

/* ---------------------------------- COMPUTED -------------------------------- */
const options = computed<LeadSelectOption[]>(() =>
  Object.entries(availableLanguages).map(([code, language]) => ({
    value: code,
    label: `${language.label} - ${language.country}`,
  }))
);

/* ---------------------------------- METHODS --------------------------------- */
/** changing the language reloads the page, so there is nothing to bind back to */
function onSelect(value: string | string[] | null) {
  setLanguage(String(value ?? ''));
}
</script>
